
//The host that will be used for api requests
var DEFAULT_HOST = 'data.pointblue.org';